import { useState } from "react";
import CustomText from "../atomic/CustomText";
import { ColumnDef, ColumnFiltersState } from "@tanstack/react-table";
import DataTable from "../global/DataTable";
import useQueryParams from "../../services/utils/custom hooks/QueryHelper";
import useProfile from "../../services/utils/custom hooks/useProfile";

function AssociatedOrganizationAndRolesTable({
  isLoading,
  data,
  tableContainerClass,
}: {
  isLoading: boolean;
  data: any[];
  tableContainerClass?: string;
}): JSX.Element {
  const query = useQueryParams();
  const { data: profileData, isLoading: isLoadingProfile, isError: profileError } = useProfile();
  const [columns, setColumns] = useState<ColumnDef<any, unknown>[]>([
    {
      accessorKey: "numbering",
      header: "",
      enableColumnFilter: false,
      cell: ({ cell, row }) => <p>{row.index + 1}</p>,
    },
    {
      accessorKey: "name",
      header: "Name",
      meta: {
        placeholder: "Filter",
      },
    },
    {
      accessorKey: "roles",
      header: "Roles",
      meta: {
        placeholder: "Filter",
      },
    },
  ]);
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>(
    columns
      .map((column: any) => ({
        id: column.accessorKey,
        value: query.get(column.accessorKey),
      }))
      .filter((data) => !!data.value)
  );
  const [params, setParams] = useState<string>("");
  return (
    <div className="md:mt-5 xs:px-3 md:px-5 xs:overflow-auto">
      <CustomText
        text={`Associated ${profileData?.user?.roles?.includes('PathLab User') ? 'PathLab' : 'Organization'} & Roles`}
        fontWeight="font-semibold"
        className="my-5"
      />
      <DataTable
        tableContainerClass={tableContainerClass}
        columns={columns}
        setParams={setParams}
        columnFilters={columnFilters}
        isFetching={isLoading}
        setColumnFilters={setColumnFilters}
        enableClientSideFiltering
        enableClientSideSorting
        data={Array.isArray(data) ? data : []}
      // rowClickable={true}
      />
    </div>
  );
}

export default AssociatedOrganizationAndRolesTable;
